import CheckBox from "@/components/elements/check-box";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  confirmCallback: (data: Record<string, boolean>) => void;
  refetch?: () => void;
};

export default function ConfirmKick({
  onOpenChange,
  open,
  confirmCallback,
  refetch,
}: Props) {
  const { t } = useTranslation();
  const [checked, setChecked] = useState({
    drug: false,
    test: false,
    pic: false,
    rest: false,
  });

  const options = [
    { key: "drug", label: t("drug") },
    { key: "test", label: t("test") },
    { key: "pic", label: t("pic") },
    { key: "rest", label: t("rest") },
  ] as const;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("finishe")}</DialogTitle>
          <DialogDescription>{t("doctor_note")}</DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {options.map(({ key, label }) => (
            <CheckBox
              key={key}
              checked={checked[key]}
              onChange={(next) => setChecked((s) => ({ ...s, [key]: next }))}
              label={label}
            />
          ))}
        </div>

        <div className="mt-5 flex gap-2">
          <Button
            variant="outline"
            className="font-medium rounded-md flex-1"
            onClick={() => onOpenChange(false)}
          >
            {t("cancel")}
          </Button>
          <Button
            className="font-medium rounded-md flex-1"
            onClick={() => {
              confirmCallback(checked);
              onOpenChange(false);
              if (refetch) {
                refetch();
              }
            }}
          >
            {t("end_visit")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
